/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Forside_Hero_Title_AfterInputs */

const da_forside_hero_title_after = /** @type {(inputs: Forside_Hero_Title_AfterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (` – med dig som den, der bedømmer.`)
};

/** @type {(inputs: Forside_Hero_Title_AfterInputs) => LocalizedString} */
const en_forside_hero_title_after = da_forside_hero_title_after;

/**

* @param {Forside_Hero_Title_AfterInputs} inputs
* @param {{ locale?: "da" | "en" }} options
* @returns {LocalizedString}
*/
export const forside_hero_title_after = /** @type {((inputs?: Forside_Hero_Title_AfterInputs, options?: { locale?: "da" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Forside_Hero_Title_AfterInputs, { locale?: "da" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_forside_hero_title_after(inputs)
	return /** @type {LocalizedString} */ (" – med dig som den, der bedømmer.")
});